import React from 'react';
import clsx from 'clsx';
import { Typography, makeStyles } from '@material-ui/core';

export const ORDER_DETAIL_CHARGE = 'ORDER_DETAIL_CHARGE';
export const ORDER_DETAIL_TOTAL = 'ORDER_DETAIL_TOTAL';
export const NXT_CART = 'NXT_CART';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  [ORDER_DETAIL_CHARGE]: {
    '& h6': {
      fontSize: '1rem',
      paddingLeft: '1rem',
      paddingRight: '.5rem',
      paddingBottom: '0.3rem'
    }
  },
  [ORDER_DETAIL_TOTAL]: {
    '& h6': {
      fontSize: '1rem',
      paddingLeft: '1rem',
      paddingRight: '.5rem',
      color: '#000000',
      fontWeight: 700
    }
  },
  [NXT_CART]: {
    marginTop: '70px'
  }
}));

const NxtTxtApart = ({
  left,
  right,
  leftVariant = 'subtitle1',
  rightVariant = 'subtitle1',
  leftColor = 'textPrimary',
  rightColor = 'textPrimary',
  orderDetailStyle
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, classes[orderDetailStyle])}>
      <Typography variant={leftVariant} color={leftColor}>
        {left}
      </Typography>
      <Typography variant={rightVariant} color={rightColor}>
        {right}
      </Typography>
    </div>
  );
};

export default NxtTxtApart;
